module.exports = __webpack_public_path__ + "static/media/success.3fc12c94.png";